import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Signin/Register.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import CloseForm from "../Master/CloseForm";
import Swal from "sweetalert2";
import getCookie from "../../api";
import axiosInstance from "../../api";

function Register({
  setshowcreateuser,
  refresh,
  setrefresh,
  fetchuserdata,
  triggerupdate,
}) {
  const [data, setData] = useState({
    UserID: triggerupdate ? fetchuserdata?.userID : "",
    HashPassword: triggerupdate ? fetchuserdata?.hashPassword : "",
    ConfirmHashPassword: "",
    Email: triggerupdate ? fetchuserdata?.email : "",
    MobileNumber: triggerupdate ? fetchuserdata?.mobileNumber : "",
    TokenCode: triggerupdate ? fetchuserdata?.tokenCode : "",
    Role: triggerupdate ? fetchuserdata?.role : "",
  });

  const [loading, setloading] = useState(false);
  const [roles, setroles] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  function showErrors(err) {
    if (err.response.data.error) return err.response.data.error;
    else if (err.response.data.errors) {
      if (err.response.data.errors.MobileNumber)
        return err.response.data.errors.MobileNumber[0];
    } else return err.response.data;
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (data.HashPassword !== data.ConfirmHashPassword) {
      toast.error("Password and Confirm Password Didn't Matched", {
        position: "bottom-center",
        theme: "dark",
      });
      return;
    }
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/User`;
      axiosInstance
        .put(url, data)
        .then((res) => {
          setloading(false);
          toast.success("User Updated Successfully", {
            position: "bottom-center",
          });
          setshowcreateuser(false);
          setrefresh(!refresh);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
          Swal.fire({
            icon: "error",
            title: "Error Occured",
            text: showErrors(err),
          });
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/User`;
      axiosInstance
        .post(url, data)
        .then((res) => {
          setloading(false);
          toast.success("User Created Successfully", {
            position: "bottom-center",
          });
          setshowcreateuser(false);
          setrefresh(!refresh);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
          Swal.fire({
            icon: "error",
            title: "Error Occured",
            text: showErrors(err),
          });
        });
    }
  }

  useEffect(() => {
    setroles([]);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/Permissions`)
      .then((res) => {
        console.log(res);
        const rolenames = new Set();
        for (let i = 0; i < res.data.length; i++) {
          rolenames.add(res.data[i].role);
        }
        setroles(Array.from(rolenames));
      })
      .catch(console.log);
  }, []);

  return (
    <section className="register">
      <form onSubmit={handleSubmit}>
        <h1>Register</h1>
        <blockquote>
          <label>Username</label>
          <input
            required
            type="text"
            placeholder="Enter Username (e.g user123)"
            onChange={(e) => setData({ ...data, UserID: e.target.value })}
            value={data.UserID}
            readOnly={triggerupdate}
          />
        </blockquote>
        <blockquote>
          <label>Email</label>
          <input
            required
            type="email"
            placeholder="Enter Email"
            onChange={(e) => setData({ ...data, Email: e.target.value })}
            value={data.Email}
          />
        </blockquote>
        <blockquote>
          <label>Phone Number</label>
          <input
            type="number"
            placeholder="Enter Phone Number with country code without +"
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 10);
            }}
            onChange={(e) => setData({ ...data, MobileNumber: e.target.value })}
            value={data.MobileNumber}
            required
          />
        </blockquote>
        <blockquote>
          <label>Role</label>
          <select
            onChange={(e) => setData({ ...data, Role: e.target.value })}
            required
          >
            <option value="">Select Role Name</option>
            {roles.map((role, index) => (
              <option key={index} selected={data.Role === role}>
                {role}
              </option>
            ))}
          </select>
        </blockquote>

        <blockquote>
          <label>Password</label>
          <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              onChange={(e) =>
                setData({ ...data, HashPassword: e.target.value })
              }
              required
              value={data.HashPassword}
            />
            <i
              className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            ></i>
          </blockquote>
        </blockquote>

        <blockquote>
          <label>Confirm Password</label>
          <input
            type="text"
            placeholder="Enter Password Again"
            onChange={(e) =>
              setData({ ...data, ConfirmHashPassword: e.target.value })
            }
            required
            value={data.ConfirmHashPassword}
          />
        </blockquote>

        <blockquote>
          <label>Token Code</label>
          <input
            type="text"
            placeholder="Enter Token Code (Used to Change Password)"
            onChange={(e) => setData({ ...data, TokenCode: e.target.value })}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 100);
            }}
            required
            value={data.TokenCode}
          />
        </blockquote>

        <button type={loading ? "button" : "submit"}>
          {loading ? (
            <i className="fa-solid fa-spinner fa-spin fa-2x"></i>
          ) : triggerupdate ? (
            "Edit"
          ) : (
            "Create"
          )}
        </button>
      </form>

      <CloseForm close={setshowcreateuser} />
    </section>
  );
}

export default Register;
